var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm._l(_vm.newList, function(item, index) {
        return _c("div", { key: index, staticClass: "px-3 py-3" }, [
          _c(
            "div",
            { staticClass: "rounded-border card-container card-shadow" },
            [
              item.imageUrl
                ? [
                    _c("div", { staticClass: "img__container" }, [
                      item.title
                        ? _c("img", {
                            staticClass: "rounded-border",
                            attrs: { src: item.imageUrl },
                            on: {
                              click: function($event) {
                                return _vm.viewStoryDetail(item)
                              }
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.activeActionsList == index
                      ? _c(
                          "div",
                          { staticClass: "actions__bloc" },
                          [
                            _c("GalleryActions", {
                              attrs: { actions: _vm.actions, story: item },
                              on: {
                                clicked: function($event) {
                                  return _vm.toggleActions(index, item)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeActionsList == index && 1 == -1
                      ? _c(
                          "div",
                          {
                            staticClass: "context-menu",
                            attrs: { id: "contextMenu" + index }
                          },
                          [
                            _c("ul", { staticClass: "menu" }, [
                              _c("li", { staticClass: "preview" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.goDecisionTree(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-divide" }),
                                    _vm._v(" Decision Tree")
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm._m(0, true),
                              _vm._v(" "),
                              _c("li", { staticClass: "share" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.shareStory(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-share",
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(" Share")
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "getLink" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.copyLink(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-link",
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(" Get link")
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm._m(1, true),
                              _vm._v(" "),
                              _c("li", { staticClass: "starred" }, [
                                !item.isStarred
                                  ? _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.addToStarred(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "far fa-star",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(
                                          " Add to\n                Starred"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.isStarred
                                  ? _c(
                                      "a",
                                      {
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.removeFromStarred(item)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-star",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(
                                          " Remove from\n                Starred"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _vm._m(2, true),
                              _vm._v(" "),
                              _c("li", { staticClass: "copy" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.copyStory(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-copy",
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v("Make a copy")
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "edit" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.editStoryInfo(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-edit",
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(" Edit")
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "trash" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.deleteStory(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-trash",
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(" Delete")
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", { staticClass: "download" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.downloadStory(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-download",
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(" Download")
                                  ]
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "pt-3" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    item.title
                      ? _c(
                          "h6",
                          {
                            on: {
                              click: function($event) {
                                return _vm.viewStoryDetail(item)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.title) +
                                " \n            "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 text-right" }, [
                    item.sharedWith &&
                    item.sharedWith.includes(_vm.$store.state.user.id)
                      ? _c("span", { attrs: { title: "shared with me" } }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                version: "1.1",
                                fill: "currentColor",
                                id: "Layer_1",
                                xmlns: "http://www.w3.org/2000/svg",
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                x: "0px",
                                y: "0px",
                                width: "16px",
                                height: "16px",
                                viewBox: "0 0 16 16",
                                "enable-background": "new 0 0 16 16",
                                "xml:space": "preserve"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  fill: "currentColor",
                                  d:
                                    "M12.996,10.037c-0.743,0-1.413,0.308-1.893,0.802L5.627,8.277C5.636,8.186,5.641,8.094,5.641,8S5.636,7.814,5.627,7.723l5.476-2.562c0.48,0.494,1.15,0.802,1.893,0.802c1.457,0,2.639-1.181,2.639-2.64c0-1.457-1.182-2.639-2.639-2.639c-1.458,0-2.639,1.182-2.639,2.639c0,0.094,0.005,0.186,0.014,0.277L4.895,6.163c-0.48-0.494-1.15-0.802-1.893-0.802C1.545,5.361,0.364,6.543,0.364,8c0,1.458,1.182,2.639,2.639,2.639c0.743,0,1.414-0.308,1.893-0.802l5.476,2.562c-0.009,0.091-0.014,0.183-0.014,0.277c0,1.457,1.181,2.639,2.639,2.639c1.457,0,2.639-1.182,2.639-2.639S14.454,10.037,12.996,10.037z"
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.isStarred
                      ? _c("span", { attrs: { title: "starred" } }, [
                          _c("i", { staticClass: "fa fa-star" })
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                item.author
                  ? _c("div", { staticClass: "text-gray" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icons/AuthorGray.svg"),
                          width: "20px"
                        }
                      }),
                      _vm._v(" "),
                      item.author
                        ? _c("small", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(item.author))
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text-gray d-flex justify-content-between my-2"
                  },
                  [
                    _c("div", { staticClass: "align-middle" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icons/Date.svg"),
                          width: "20px"
                        }
                      }),
                      _vm._v(" "),
                      item.date
                        ? _c("small", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(item.date))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn list-btn rounded-border p-1",
                          class: {
                            "btn-active": _vm.activeActionsList == index
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.toggleActions(index, item)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "default-icon",
                            attrs: {
                              src: require("@/assets/icons/list.svg"),
                              width: "20px"
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "icon-white",
                            attrs: {
                              src: require("@/assets/icons/list-white.svg"),
                              width: "20px"
                            }
                          })
                        ]
                      )
                    ])
                  ]
                )
              ])
            ],
            2
          )
        ])
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _vm.getLink
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        {
                          staticStyle: {
                            "padding-top": "0px",
                            "padding-bottom": "0px"
                          },
                          attrs: { "grid-list-sm": "" }
                        },
                        [
                          _c("h4", [
                            _c("i", { staticClass: "fa fa-link" }),
                            _vm._v(" GET LINK")
                          ]),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "Copy Link", id: "copyUrl" },
                            model: {
                              value: _vm.copyLinkAddress,
                              callback: function($$v) {
                                _vm.copyLinkAddress = $$v
                              },
                              expression: "copyLinkAddress"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.copyUrl()
                                }
                              }
                            },
                            [_vm._v("Copy link")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.dialog_share,
            callback: function($$v) {
              _vm.dialog_share = $$v
            },
            expression: "dialog_share"
          }
        },
        [
          _vm.share
            ? _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        {
                          staticStyle: { "padding-top": "0px" },
                          attrs: { "grid-list-sm": "" }
                        },
                        [
                          _c("h4", [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  version: "1.1",
                                  fill: "currentColor",
                                  id: "Layer_1",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  x: "0px",
                                  y: "0px",
                                  width: "16px",
                                  height: "16px",
                                  viewBox: "0 0 16 16",
                                  "enable-background": "new 0 0 16 16",
                                  "xml:space": "preserve"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d:
                                      "M12.996,10.037c-0.743,0-1.413,0.308-1.893,0.802L5.627,8.277C5.636,8.186,5.641,8.094,5.641,8S5.636,7.814,5.627,7.723l5.476-2.562c0.48,0.494,1.15,0.802,1.893,0.802c1.457,0,2.639-1.181,2.639-2.64c0-1.457-1.182-2.639-2.639-2.639c-1.458,0-2.639,1.182-2.639,2.639c0,0.094,0.005,0.186,0.014,0.277L4.895,6.163c-0.48-0.494-1.15-0.802-1.893-0.802C1.545,5.361,0.364,6.543,0.364,8c0,1.458,1.182,2.639,2.639,2.639c0.743,0,1.414-0.308,1.893-0.802l5.476,2.562c-0.009,0.091-0.014,0.183-0.014,0.277c0,1.457,1.181,2.639,2.639,2.639c1.457,0,2.639-1.182,2.639-2.639S14.454,10.037,12.996,10.037z"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" Share")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("multiselect", {
                                attrs: {
                                  options: _vm.people,
                                  searchable: true,
                                  "close-on-select": true,
                                  "show-labels": false,
                                  taggable: false,
                                  multiple: true,
                                  placeholder: "Add people to share with",
                                  "clear-on-select": false,
                                  "preserve-search": true,
                                  label: "firstName",
                                  "custom-label": _vm.fullName,
                                  "track-by": "email",
                                  "max-height": 160,
                                  "preselect-first": false
                                },
                                model: {
                                  value: _vm.sharedWith,
                                  callback: function($$v) {
                                    _vm.sharedWith = $$v
                                  },
                                  expression: "sharedWith"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "button",
                        { staticClass: "tablink", attrs: { disabled: "" } },
                        [
                          _c("i", { staticClass: "fa fa-file" }),
                          _vm._v(
                            "\n                   " +
                              _vm._s(this.storyName) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _vm.showSaveButton
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: { click: _vm.send }
                            },
                            [
                              this.saving
                                ? _c(
                                    "v-flex",
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          indeterminate: "",
                                          color: "primary"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c("v-flex", [_vm._v("Send")])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "preview" }, [
      _c("a", { attrs: { href: "#" } }, [
        _c("i", {
          staticClass: "fas fa-eye",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" Preview")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "location" }, [
      _c("a", { attrs: { href: "#" } }, [
        _c("i", {
          staticClass: "fa fa-file",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" Show file\n                location")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "rename" }, [
      _c("a", { attrs: { href: "#" } }, [
        _c("i", {
          staticClass: "fas fa-pen",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" Rename")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0935d8e8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0935d8e8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-list-view/gridCard1.vue
// module id = null
// module chunks = 